import { Alert, Checkbox, Container, FormControlLabel, Grid, Modal, Paper, Box, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react';
import Constantes from '../php/Constantes';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    }));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
let dep = '';
let sal = '';
let lug = '';
let vin = '';
let esc = '';
let ser = '';
let ent = '';
class ConsultaFuncionario extends Component{
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            datosModal: {
                numeroFuncionario: '',
            },
            consulta: false,
            datosConsulta: [],
            departamentos: [],
            escalafones: [],
            serieBase: [],
            horasEntrada: [],
            lugaresTrabajo: [],
            vinculacion: [],
            modalConsulta: false,
            datos: {
                funcionarioBuscar: '',
                ci: '',
                primerNombre: '',
                segundoNombre: '',
                primerApellido: '',
                segundoApellido: '',
                fechaNacimiento: '',
            },
        }

        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEdicion = this.manejarEdicion.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
    }
    async componentDidMount(){
        const departamento = await fetch(`${Constantes.RUTA_API}/obtener_departamentos.php`);
        const datoDepartamento = await departamento.json();
        this.setState({
            departamentos: datoDepartamento,
        });

        const datosEscalafones = await fetch(`${Constantes.RUTA_API}/obtener_escalafones.php`);
        const datoEscalafon = await datosEscalafones.json();
        this.setState({
            escalafones: datoEscalafon,
        });

        const serie = await fetch(`${Constantes.RUTA_API}/obtener_series.php`);
        const datoSerie = await serie.json();
        this.setState({
            serieBase: datoSerie,
        });

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntrada: datosEntrada,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTrabajo: datoLugar,
        });

        const vin = await fetch(`${Constantes.RUTA_API}/obtener_vinculaciones.php`);
        const dat = await vin.json();
        this.setState({
            vinculacion: dat,
        });

    }
    render(){
        return (
            <>
                {!this.state.modalConsulta
                ?
                    <Container>
                        <h3>Datos Funcionarios</h3>
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        <form className='formulario'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2.1}>
                                    </Grid>
                                    <Grid item xs={2.2}>
                                        <Item>Funcionario a buscar <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='funcionarioBuscar' value={this.state.datos.funcionarioBuscar} onChange={this.manejarCambiosDatos} type="text" />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    </Container>
                :
                    null
                }
                {!this.state.modalConsulta
                ?
                    <Container>
                        {this.state.consulta
                        ?
                            <TableContainer style={{width: '90%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Nº Funcionario</StyledTableCell>
                                            <StyledTableCell>P. Nombre</StyledTableCell>
                                            <StyledTableCell>S. Nombre</StyledTableCell>
                                            <StyledTableCell>P. Apellido</StyledTableCell>
                                            <StyledTableCell>S. Apellido</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosConsulta.map((dat) => (
                                            <StyledTableRow key={dat.numeroFuncionario}>
                                                <StyledTableCell>{dat.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell>{dat.primerNombre}</StyledTableCell>
                                                <StyledTableCell>{dat.segundoNombre}</StyledTableCell>
                                                <StyledTableCell>{dat.primerApellido}</StyledTableCell>
                                                <StyledTableCell>{dat.segundoApellido}</StyledTableCell>
                                                <StyledTableCell><button className="btn btn-outline-danger mx-2" onClick={() => this.manejarEdicion(dat)}>Consultar</button></StyledTableCell>
                                            </StyledTableRow>
                                        ))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        :
                            null
                        }
                        <br/>
                        <br/>
                    </Container>
                :
                    null
                }
                {this.state.modalConsulta
                ?
                    <Container>
                        <Box sx={{ flexGrow: 1}}>
                            <h3 style={{textAlign:'center'}}>Datos Funcionario</h3>
                            <fieldset>
                            <legend>DATOS PERSONALES</legend>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2.5}>
                                        <Item>Nº Funcionario</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>{this.state.datosModal.numeroFuncionario}</Item>
                                    </Grid>
                                    <Grid item xs={1}>

                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>C.I.</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>{this.state.datosModal.ci}</Item>
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>P. Nombre</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>{this.state.datosModal.primerNombre}</Item>
                                    </Grid>
                                    <Grid item xs={1}>

                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>P. Nombre</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>{this.state.datosModal.segundoNombre}</Item>
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>P. Apellido</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>{this.state.datosModal.primerApellido}</Item>
                                    </Grid>
                                    <Grid item xs={1}>

                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>S. Apellido</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>{this.state.datosModal.segundoApellido}</Item>
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>F. Nacimiento</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>{String(this.state.datosModal.fechaNacimiento).substring(8,10) + '/' + String(this.state.datosModal.fechaNacimiento).substring(5,7) + '/' + String(this.state.datosModal.fechaNacimiento).substring(0,4)}</Item>
                                    </Grid>
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>CREDENCIAL</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>{this.state.datosModal.credencialSerie + ' ' + this.state.datosModal.credencialNumero}</Item>
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>DIRECCION</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>{this.state.datosModal.direccionCalle + ' ' + this.state.datosModal.direccionNumero}</Item>
                                    </Grid>
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>LOCALIDAD</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>{this.state.datosModal.direccionLocalidad}</Item>
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>DEPARTAMENTO</Item>
                                    </Grid>
                                    {this.state.departamentos.map((name2) => {
                                        if(name2.idDepartamentos === this.state.datosModal.direccionDepartamento){
                                            dep = name2.descripcion;
                                        }
                                    })}
                                    <Grid item xs={3}>
                                        <Item>{dep}</Item>
                                    </Grid>
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>TELEFONO</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>{this.state.datosModal.telefono}</Item>
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>CELULAR</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>{this.state.datosModal.celular}</Item>
                                    </Grid>
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>CARNE DE SALUD</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>{String(this.state.datosModal.carneSalud).substring(8,10) + '/' + String(this.state.datosModal.carneSalud).substring(5,7) + '/' + String(this.state.datosModal.carneSalud).substring(0,4)}</Item>
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>SEXO</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        {this.state.datosModal.sexo === 0 ? <Item>MASCULINO</Item> : <Item>FEMENINO</Item> }
                                    </Grid>
                                </Grid>
                            </fieldset>
                            <br/>
                            <br/>
                            <fieldset>
                                <legend>DATOS FUNCIONARIO</legend>
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2.5}>
                                            <Item>NUMERO FUNCIONARIO</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Item>{this.state.datosModal.numeroFuncionario}</Item>
                                        </Grid>
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>FECHA DE INGRESO</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                        <Item>{String(this.state.datosModal.ingresoInstitucion).substring(8,10) + '/' + String(this.state.datosModal.ingresoInstitucion).substring(5,7) + '/' + String(this.state.datosModal.ingresoInstitucion).substring(0,4)}</Item>
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>CARGO</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Item>{this.state.datosModal.cargo}</Item>
                                        </Grid>
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>ESCALAFON</Item>
                                        </Grid>
                                        {this.state.escalafones.map((name2) => {
                                            if(name2.idEscalafon === this.state.datosModal.escalafon){
                                                esc = name2.descripcion;
                                            }
                                        })}
                                        <Grid item xs={3}>
                                            <Item>{esc}</Item>
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>GRADO</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Item>{this.state.datosModal.grado}</Item>
                                        </Grid>
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>SERIE CONCURSO</Item>
                                        </Grid>
                                        {this.state.serieBase.map((name2) => {
                                            if(name2.idSerie === this.state.datosModal.serieConcurso){
                                                ser = name2.descripcion;
                                            }
                                        })}
                                        <Grid item xs={3}>
                                            <Item>{ser}</Item>
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>LUGAR DE TRABAJO</Item>
                                        </Grid>
                                        {this.state.lugaresTrabajo.map((name2) => {
                                            if(name2.idLugaresTrabajo === this.state.datosModal.lugar){
                                                lug = name2.lugar;
                                            }
                                        })}
                                        <Grid item xs={3}>
                                            <Item>{lug}</Item>
                                        </Grid>
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>VINCULACION</Item>
                                        </Grid>
                                        {this.state.vinculacion.map((name2) => {
                                            if(name2.idVinculacion === this.state.datosModal.vinculacion){
                                                vin = name2.descripcion;
                                            }
                                        })}
                                        <Grid item xs={3}>
                                            <Item>{vin}</Item>
                                        </Grid>
                                        
                                        <Grid item xs={5.5}>
                                            
                                        </Grid>
                                        <Grid>
                                            <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Volver</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </fieldset>
                        </Box>
                    </Container>
                :
                    null
                }
                {/*<Modal open={this.state.modalConsulta}>
                    <form className='formulario1'>
                        <Box sx={styleModal}>
                            <h3 style={{textAlign:'center'}}>Datos Funcionario</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.5}>
                                    <Item>Nº Funcionario</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item>{this.state.datosModal.numeroFuncionario}</Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={2.5}>
                                    <Item>C.I.</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item>{this.state.datosModal.ci}</Item>
                                </Grid>
                                <Grid item xs={2.5}>
                                    <Item>P. Nombre</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item>{this.state.datosModal.primerNombre}</Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={2.5}>
                                    <Item>P. Nombre</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item>{this.state.datosModal.segundoNombre}</Item>
                                </Grid>
                                <Grid item xs={2.5}>
                                    <Item>P. Apellido</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item>{this.state.datosModal.primerApellido}</Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={2.5}>
                                    <Item>S. Apellido</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item>{this.state.datosModal.segundoApellido}</Item>
                                </Grid>
                                <Grid>
                                    <button className="btn btn-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cerrar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>*/}
            </>
        )//Final return
    }//Final Render

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if(this.state.datos.funcionarioBuscar === ''){
            this.setState({
                errores: 'DEBE INDICAR LOS DATOS DEL FUNCIONARIO A BUSCAR',
            });
        }else{
            const cargaUtil = JSON.stringify([this.state.datos]);
            const respuesta = await fetch(`${Constantes.RUTA_API}/consultar_Funcionario.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            if(exito[0] !== 0){
                this.setState({
                    notificaciones : null,
                    errores: null,
                    consulta: true,
                    datosConsulta: exito[1],
                });
            }else{
                this.setState({
                    errores: 'NO SE ENCONTRARON DATOS',
                });
            }
            
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            datosConsulta: [],
            consulta: false,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const funcionarioActualizado = state.datos;
            funcionarioActualizado[clave] = valor;
            return{
                datos: funcionarioActualizado,
            };
        })
    }

    manejarEdicion(dat){
        this.setState({
            modalConsulta: true,
            datosModal: dat,
            notificaciones: null,
            errores: null,
        });
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            modalConsulta: false,
        });
    }
}

export default ConsultaFuncionario